import React from "react";
import PropTypes from 'prop-types';

const Card = ({ title, content, icon, alt = "" }) => {
    return (
        <li className="w-full min-h-full">
            <div className="h-full bg-green-200 rounded-lg shadow-md p-6 md:py-8 max-w-md hover:shadow-lg hover:scale-105 transition-all duration-300">
                <span className="flex flex-row items-center gap-2">
                    <img className="w-6" src={icon} alt={alt} />
                    <h3 className="mb-0 text-xl font-bold mb-4 text-gray-800">{title}</h3>
                </span>
                <p className="text-gray-600">{content}</p>
            </div>
        </li>
    );
};

export default Card;

Card.propTypes = {
    title: PropTypes.string,
    content: PropTypes.string,
    icon: PropTypes.node,
    alt: PropTypes.string
}